<template>
	<v-container
		fluid
	>
		<v-row>
			<v-col>
				<v-row>
					<v-col>
						<product-edit
							:product-id="productId"
						/>
					</v-col>
					<v-col>
						<a-b-test-list
							ref="list"
							:product-id="productId"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<product-versions
							:product-id="productId"
							@copy="updateProductVersions"
						/>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import ProductVersions from '../../../molecules/ProductVersions.vue';
import ABTestList from '../../../molecules/ABTestList.vue';
import ProductEdit from '../../../molecules/ProductEdit.vue';
export default {
	name: 'ProductView',

	components: {
		ProductEdit,
		ABTestList,
		ProductVersions
	},

	props: {
		productId: {
			type: Number,
			required: true
		}
	},

	methods: {
		/**
		 * trigger a/b testing list update
		 */
		updateProductVersions () {
			this.$refs.list.getProductVersions();
		}
	}
};
</script>

<style scoped>

</style>
